Core.ArticlesRouter = Core.SubRouter.extend({
    routes: {
        '': 'articles',
        'itemsummary': 'summary',
        'new': 'newArticle',
        ':id': 'editArticle',
    },

    articles: function () {
      debug.log('articles');
      app.setMainView(new ArticleListView({scrolling: true}), 'directory');
    },

    newArticle: function () {
      debug.log('newArticle');
      app.setMainView(new ArticleListView({scrolling: true}), 'directory').showDetails(null);
    },

    editArticle: function (id) {
        debug.log('newArticle');
        var view = new ArticleListView({scrolling: true});
        if (view.collection.length == 0 || !view.collection.get(id)) {
            console.log('fetch detail article');
            var article = new Core.Article({id: id});
            article.fetch().success(function() {
                view.collection.add(article);
                view.showDetails(id);
            }).error(function (response) { errorResponse(response.responseText); });
        } else
            view.showDetails(id);
        app.setMainView(view, 'directory');
    },

    summary: function () {
        debug.log('item summary');
        app.setMainView(new ItemSummaryView(), 'directory');
    }

});
